import { useLink } from 'vue-router';

export const useBannersButtonsLinks = () => {
    const { query } = useRoute();

    const loginTo = {
        name: 'auth',
        query,
    };

    const registerTo = {
        ...loginTo,
        query: {
            ...query,
            tab: 'register',
        },
    };

    const { href: hrefLogin } = useLink({ to: loginTo });
    const { href: hrefRegister } = useLink({ to: registerTo });

    const config = useRuntimeConfig();
    const computedHrefLogin = computed(() => {
        return `${config.public.baseUrl}${hrefLogin.value}`;
    });
    const computedHrefRegister = computed(() => {
        return `${config.public.baseUrl}${hrefRegister.value}`;
    });

    return {
        computedHrefRegister,
        computedHrefLogin,
    };
};
